import { useEffect, useState } from "react";

/*
 * AE2C Enterprise ERP – Navigation Header (React)
 *
 * index.html needs:
 *   Font Awesome is bundled (src/index.css imports @fortawesome/fontawesome-free) - no CDN link needed.
 *   Tailwind (CDN or build)
 *
 * With React Router:
 *   import { Link } from "react-router-dom";
 *   <AE2CNavbar LinkComponent={({ href, ...p }) => <Link to={href} {...p} />} />
 */

/* ───────────────────────── MENU CONFIG (exported so pages can reuse it) ───────────────────────── */
/* ───────────────────────── NAVBAR (mirrors the PHP header.php menu) ─────────────────────────
   admin: true  -> shown only to admins (the PHP <?php if ($is_admin): ?> blocks)
   type: "label" | "divider" | link (default) */
export const MENU = [
  { key: "dashboard", label: "Dashboard", icon: "fa-gauge-high", href: "dashboard" },
  {
    key: "sales",
    label: "Sales",
    icon: "fa-cash-register",
    items: [
      { type: "label", label: "Operations" },
      { label: "Point of Sale", href: "pos", icon: "fa-cash-register", color: "text-green-500" },
      { label: "End of Day", href: "end_of_day", icon: "fa-moon", color: "text-indigo-500" },
      { label: "End of Day History", href: "end_of_day_history", icon: "fa-clock-rotate-left", color: "text-blue-600" },
      { type: "divider", admin: true },
      { type: "label", label: "Analytics", admin: true },
      { label: "Daily Sales", href: "sales_day", icon: "fa-calendar-day", color: "text-sky-500", admin: true },
      { label: "Sales Analytics", href: "sales", icon: "fa-chart-column", color: "text-emerald-500", admin: true },
      { label: "Deep Sales", href: "salesExtend", icon: "fa-chart-pie", color: "text-rose-500", admin: true },
      { label: "Sales Individual", href: "saleIndividual", icon: "fa-user-tie", color: "text-orange-500", admin: true },
    ],
  },
  {
    key: "inventory",
    label: "Inventory",
    icon: "fa-boxes-stacked",
    items: [
      { type: "label", label: "Manage" },
      { label: "Update Inventory", href: "update_barcode", icon: "fa-barcode", color: "text-slate-500" },
      { label: "Update Stock", href: "productedit", icon: "fa-pen-to-square", color: "text-indigo-500" },
      { label: "Mixed Crate Sales", href: "wholesale_pos", icon: "fa-boxes-stacked", color: "text-emerald-500" },
      { label: "Wholesale Pricing", href: "wholesale_prices", icon: "fa-tag", color: "text-amber-500" },
      { label: "Stock Reconciliation", href: "stockrecon", icon: "fa-clipboard-list", color: "text-violet-500" },
      { label: "Reconciliation Report", href: "stockrecon_report", icon: "fa-calendar-days", color: "text-violet-400" },
      { label: "Create Purchasing Items", href: "purchasing", icon: "fa-cart-plus", color: "text-blue-500" },
      { type: "divider" },
      { type: "label", label: "Decision Support" },
      { label: "Expiry Dashboard", href: "expiry_dashboard", icon: "fa-hourglass-end", color: "text-amber-500" },
      { label: "Urgent Products", href: "availabilty", icon: "fa-triangle-exclamation", color: "text-red-500" },
      { label: "Zero Stock Report", href: "report_zero_stock", icon: "fa-box-open", color: "text-red-400" },
      { label: "Purchase History", href: "purchase_history", icon: "fa-clock-rotate-left", color: "text-purple-500" },
      { label: "Stock Position", href: "stockStatus", icon: "fa-layer-group", color: "text-cyan-500", admin: true },
      { type: "divider" },
      { label: "Product List (Print)", href: "productprint", icon: "fa-box-open", color: "text-amber-500" },
    ],
  },
  {
    key: "finance",
    label: "Finance",
    icon: "fa-coins",
    items: [
      { type: "label", label: "Transactions" },
      { label: "Pending Transactions", href: "verify-payment", icon: "fa-hourglass-half", color: "text-amber-500", admin: true },
      { label: "Asset Transactions", href: "assetTransaction", icon: "fa-building-columns", color: "text-blue-500" },
      { label: "Liability Transactions", href: "liabilityTransaction", icon: "fa-scale-balanced", color: "text-purple-500" },
      { label: "Pre-payments", href: "ext_fund", icon: "fa-money-bill-trend-up", color: "text-emerald-500" },
      { type: "divider", admin: true },
      { type: "label", label: "Statements & Ledgers", admin: true },
      { label: "Account Balances", href: "accountBalance", icon: "fa-wallet", color: "text-green-500", admin: true },
      { label: "Transaction Entries", href: "accountBalanceL", icon: "fa-arrow-right-arrow-left", color: "text-blue-500", admin: true },
      { label: "Trial Balance", href: "trial_balance", icon: "fa-scale-balanced", color: "text-purple-500", admin: true },
      { label: "Journal Entry", href: "journal_entry", icon: "fa-book-open", color: "text-amber-600", admin: true },
      { label: "Account Statement", href: "accountStatement", icon: "fa-file-lines", color: "text-slate-500", admin: true },
      { type: "divider", admin: true },
      { type: "label", label: "Reports", admin: true },
      { label: "Financial Reports", href: "financialReports", icon: "fa-chart-column", color: "text-indigo-500", admin: true },
      { label: "Cash Flow", href: "cashflow", icon: "fa-money-bill-wave", color: "text-teal-500", admin: true },
      { label: "Analytics", href: "reportAnalytics", icon: "fa-chart-simple", color: "text-rose-500", admin: true },
      { label: "Service Payments Report", href: "service_payments_report", icon: "fa-briefcase", color: "text-cyan-500", admin: true },
      { type: "divider" },
      { type: "label", label: "Mobile Money" },
      { label: "MNO Lines & Float", href: "mobile_money_float", icon: "fa-wallet", color: "text-amber-500", admin: true },
      { label: "Commission Report", href: "mobile_money_report", icon: "fa-chart-simple", color: "text-rose-500", admin: true },
    ],
  },
  {
    key: "customers",
    label: "Customers",
    icon: "fa-users",
    items: [
      { type: "label", label: "Manage" },
      { label: "Client Management", href: "client", icon: "fa-user-group", color: "text-blue-500" },
      { label: "Service Catalog", href: "ServiceList", icon: "fa-list-check", color: "text-purple-500" },
      { label: "MNO Transactions", href: "mobile_money", icon: "fa-money-bill-transfer", color: "text-green-600" },
      { label: "MNO Transaction History", href: "mobile_money_history", icon: "fa-clock-rotate-left", color: "text-blue-600" },
      { label: "Service Payments Report", href: "service_payments_report", icon: "fa-briefcase", color: "text-cyan-500" },
      { label: "Send SMS", href: "clientSms", icon: "fa-comment-sms", color: "text-violet-500" },
      { type: "divider" },
      { type: "label", label: "Documents" },
      { label: "Print Invoice", href: "invoiceCall", icon: "fa-file-invoice", color: "text-green-500" },
      { label: "Print Purchase Order", href: "poCall", icon: "fa-file-contract", color: "text-orange-500" },
      { label: "Goods Received Note", href: "grn-report", icon: "fa-truck-ramp-box", color: "text-cyan-500" },
      { label: "Receipts", href: "GRNreceipts", icon: "fa-receipt", color: "text-emerald-500" },
    ],
  },
];

export const ACCOUNT_ITEMS = [
  { type: "label", label: "Account" },
  { label: "My Profile", href: "profile", icon: "fa-user-pen", color: "text-blue-500" },
  { label: "My Payslips & Leave", href: "my_hr", icon: "fa-id-badge", color: "text-blue-500" },
  { label: "Money Calculator", href: "refill", icon: "fa-calculator", color: "text-cyan-500" },
  { type: "divider", admin: true },
  { type: "label", label: "Administration", admin: true },
  { label: "User Management", href: "user-management", icon: "fa-users-gear", color: "text-purple-500", admin: true },
  { label: "Human Resources", href: "HrMng", icon: "fa-users-gear", color: "text-indigo-500", admin: true },
  { label: "Active Sessions", href: "active_sessions", icon: "fa-signal", color: "text-green-500", admin: true },
  { label: "Activity Logs", href: "logs", icon: "fa-timeline", color: "text-orange-500", admin: true },
];

/** Items this user may see: admin-only entries removed, then labels/dividers left with nothing under them dropped. */
export function visibleItems(items, isAdmin) {
  const kept = items.filter((i) => isAdmin || !i.admin);
  const out = [];
  kept.forEach((it, idx) => {
    if (it.type === "label") {
      const next = kept.slice(idx + 1).find((x) => x.type !== "label");
      if (!next || next.type === "divider") return; // a heading with no links under it
    }
    if (it.type === "divider" && (out.length === 0 || out[out.length - 1].type === "divider" || idx === kept.length - 1)) return;
    out.push(it);
  });
  while (out.length && out[out.length - 1].type === "divider") out.pop();
  return out;
}

// Titles, icons and sections for pages that are NOT in the navbar (reached from hubs, buttons and links).
// Breadcrumbs and page headers look pages up here when they aren't in MENU.
const PAGE_CATALOG = [
  { key: "statements", label: "Finance", items: [
    { label: "Balance Sheet", href: "callBalancesheet", icon: "fa-scale-unbalanced", color: "text-indigo-500" },
    { label: "Balance Sheet", href: "balanceSheet", icon: "fa-scale-unbalanced", color: "text-indigo-500" },
    { label: "Income Statement", href: "income_statement", icon: "fa-file-invoice-dollar", color: "text-emerald-500" },
    { label: "Income Statement", href: "callFinance", icon: "fa-file-invoice-dollar", color: "text-emerald-500" },
  ] },
  { key: "dashboard", label: "Dashboard", icon: "fa-gauge-high", href: "dashboard" },
  {
    key: "sales",
    label: "Sales",
    icon: "fa-cash-register",
    items: [
      { type: "label", label: "Operations" },
      { label: "Point of Sale", href: "pos", icon: "fa-cash-register", color: "text-green-500" },
      { label: "Warehouse POS", href: "warehousePos", icon: "fa-warehouse", color: "text-teal-500" },
      { label: "End of Day", href: "end_of_day", icon: "fa-moon", color: "text-indigo-500" },
      { label: "End of Day History", mobileLabel: "EOD History", href: "end_of_day_history", icon: "fa-clock-rotate-left", color: "text-blue-600" },
      { type: "divider" },
      { type: "label", label: "Analytics" },
      { label: "Daily Sales", href: "sales_day", icon: "fa-calendar-day", color: "text-sky-500" },
      { label: "Sales Analytics", href: "sales", icon: "fa-chart-column", color: "text-emerald-500" },
      { label: "Deep Sales", href: "salesExtend", icon: "fa-chart-pie", color: "text-rose-500" },
      { label: "Product Sales History", href: "saleIndividual", icon: "fa-magnifying-glass-chart", color: "text-orange-500" },
      { label: "Daily Dashboard", href: "sales_analysis", icon: "fa-chart-line", color: "text-indigo-500" },
      { label: "Periodic Analytics", href: "saledates", icon: "fa-calendar-days", color: "text-teal-500" },
      { label: "Compare Products", href: "sales-report", icon: "fa-code-compare", color: "text-violet-500" },
    ],
  },
  {
    key: "inventory",
    label: "Inventory",
    icon: "fa-boxes-stacked",
    items: [
      { type: "label", label: "Manage" },
      { label: "Update Inventory", href: "update_barcode", icon: "fa-barcode", color: "text-slate-500" },
      { label: "Update Stock", href: "productedit", icon: "fa-pen-to-square", color: "text-indigo-500" },
      { label: "Add Product", href: "productAdd", icon: "fa-square-plus", color: "text-green-500" },
      { label: "Adjust Stock & Prices", href: "adjust_stock", icon: "fa-sliders", color: "text-indigo-400" },
      { label: "Replenish Stock", href: "stockReprenish", icon: "fa-truck-ramp-box", color: "text-emerald-500" },
      { label: "Replenishment History", href: "addStockreplenish", icon: "fa-clock-rotate-left", color: "text-emerald-400" },
      { label: "Stock List", href: "addStock", icon: "fa-table-list", color: "text-slate-500" },
      { label: "Mixed Crate Sales", href: "wholesale_pos", icon: "fa-boxes-stacked", color: "text-emerald-500" },
      { label: "Wholesale Pricing", href: "wholesale_prices", icon: "fa-tag", color: "text-amber-500" },
      { label: "Stock Reconciliation", href: "stockrecon", icon: "fa-clipboard-list", color: "text-violet-500" },
      { label: "Reconciliation Report", href: "stockrecon_report", icon: "fa-calendar-days", color: "text-violet-400" },
      { label: "Create Purchasing Items", href: "purchasing", icon: "fa-cart-plus", color: "text-blue-500" },
      { type: "divider" },
      { type: "label", label: "Decision Support" },
      { label: "Expiry Dashboard", href: "expiry_dashboard", icon: "fa-hourglass-end", color: "text-amber-500" },
      { label: "Urgent Products", href: "availabilty", icon: "fa-triangle-exclamation", color: "text-red-500" },
      { label: "Zero Stock Report", href: "report_zero_stock", icon: "fa-box-open", color: "text-red-400" },
      { label: "Purchase History", href: "purchase_history", icon: "fa-clock-rotate-left", color: "text-purple-500" },
      { label: "Stock Position", href: "stockStatus", icon: "fa-layer-group", color: "text-cyan-500" },
      { label: "Expiring in 30 Days", href: "stockexpiry", icon: "fa-calendar-xmark", color: "text-amber-600" },
      { label: "Stock Availability %", href: "stockanalytics", icon: "fa-percent", color: "text-rose-400" },
      { label: "Inventory Overview", href: "stockAnalysis", icon: "fa-chart-column", color: "text-indigo-500" },
      { label: "Stock Management", href: "stockMgt", icon: "fa-boxes-stacked", color: "text-slate-500" },
      { label: "Stock Refill Report", href: "refill", icon: "fa-truck-ramp-box", color: "text-cyan-500" },
      { type: "divider" },
      { label: "Product List (Print)", href: "productprint", icon: "fa-print", color: "text-amber-500" },
    ],
  },
  {
    key: "finance",
    label: "Finance",
    icon: "fa-coins",
    items: [
      { type: "label", label: "Transactions" },
      { label: "Pending Transactions", href: "verify-payment", icon: "fa-hourglass-half", color: "text-amber-500" },
      { label: "Asset Transactions", href: "assetTransaction", icon: "fa-building-columns", color: "text-blue-500" },
      { label: "Liability Transactions", href: "liabilityTransaction", icon: "fa-scale-balanced", color: "text-purple-500" },
      { label: "Pre-payments", href: "ext_fund", icon: "fa-money-bill-trend-up", color: "text-emerald-500" },
      { label: "Receive Cash", href: "ReceiveCash", icon: "fa-hand-holding-dollar", color: "text-green-600" },
      { label: "Receive Invoice Payment", href: "receive_payment", icon: "fa-file-invoice-dollar", color: "text-blue-600" },
      { label: "Run Payroll", href: "run-payroll", icon: "fa-money-check-dollar", color: "text-purple-500" },
      { label: "Revenue Transactions", href: "revenuetransaction", icon: "fa-arrow-trend-up", color: "text-emerald-600" },
      { label: "Fixed Assets", href: "assets", icon: "fa-building", color: "text-slate-500" },
      { label: "Register Asset", href: "asset_register", icon: "fa-building-circle-check", color: "text-slate-400" },
      { type: "divider" },
      { type: "label", label: "Statements & Ledgers" },
      { label: "Account Balances", href: "accountBalance", icon: "fa-wallet", color: "text-green-500" },
      { label: "Transaction Entries", href: "accountBalanceL", icon: "fa-arrow-right-arrow-left", color: "text-blue-500" },
      { label: "Trial Balance", href: "trial_balance", icon: "fa-scale-balanced", color: "text-purple-500" },
      { label: "Journal Entry", href: "journal_entry", icon: "fa-book-open", color: "text-amber-600" },
      { label: "Account Statement", href: "accountStatement", icon: "fa-file-lines", color: "text-slate-500" },
      { label: "Payables (GRN)", href: "payableList", icon: "fa-file-invoice-dollar", color: "text-red-500" },
      { label: "Add Account", href: "account_form", icon: "fa-book", color: "text-indigo-500" },
      { type: "divider" },
      { type: "label", label: "Reports" },
      { label: "Financial Reports", href: "financialReports", icon: "fa-chart-column", color: "text-indigo-500" },
      { label: "Cash Flow", href: "cashflow", icon: "fa-money-bill-wave", color: "text-teal-500" },
      { label: "Analytics", href: "reportAnalytics", icon: "fa-chart-simple", color: "text-rose-500" },
      { label: "Service Payments Report", href: "service_payments_report", icon: "fa-briefcase", color: "text-cyan-500" },
      { type: "divider" },
      { type: "label", label: "Mobile Money" },
      { label: "MNO Lines & Float", href: "mobile_money_float", icon: "fa-wallet", color: "text-amber-500" },
      { label: "Commission Report", href: "mobile_money_report", icon: "fa-chart-simple", color: "text-rose-500" },
    ],
  },
  {
    key: "customers",
    label: "Customers",
    icon: "fa-users",
    items: [
      { type: "label", label: "Manage" },
      { label: "Client Management", href: "client", icon: "fa-user-group", color: "text-blue-500" },
      { label: "Service Catalog", href: "ServiceList", icon: "fa-list-check", color: "text-purple-500" },
      { label: "MNO Transactions", href: "mobile_money", icon: "fa-money-bill-transfer", color: "text-green-600" },
      { label: "MNO Transaction History", href: "mobile_money_history", icon: "fa-clock-rotate-left", color: "text-blue-600" },
      { label: "Service Payments Report", href: "service_payments_report", icon: "fa-briefcase", color: "text-cyan-500" },
      { label: "Send SMS", href: "clientSms", icon: "fa-comment-sms", color: "text-violet-500" },
      { type: "divider" },
      { type: "label", label: "Documents" },
      { label: "Print Invoice", href: "invoiceCall", icon: "fa-file-invoice", color: "text-green-500" },
      { label: "Create Purchase Order", href: "purchase_order", icon: "fa-file-circle-plus", color: "text-orange-500" },
      { label: "Purchase Orders", href: "po_list", icon: "fa-file-contract", color: "text-orange-400" },
      { label: "Receive Goods (GRN)", href: "grn", icon: "fa-truck-ramp-box", color: "text-cyan-600" },
      { label: "GRN Register", href: "grn_list", icon: "fa-clipboard-list", color: "text-cyan-500" },
      { label: "Print Purchase Order", href: "poCall", icon: "fa-file-contract", color: "text-orange-500" },
      { label: "Approved Purchase Orders", href: "Approvedpo_list", icon: "fa-file-circle-check", color: "text-green-600" },
      { label: "Goods Received Note", href: "grn-report", icon: "fa-truck-ramp-box", color: "text-cyan-500" },
      { label: "Receipts", href: "GRNreceipts", icon: "fa-receipt", color: "text-emerald-500" },
    ],
  },
];

const ACCOUNT_CATALOG = [
  { type: "label", label: "Account" },
  { label: "My Profile", href: "profile", icon: "fa-user-pen", color: "text-blue-500" },
  { label: "My Payslips & Leave", href: "my_hr", icon: "fa-id-badge", color: "text-blue-500" },
  { type: "divider" },
  { type: "label", label: "Administration" },
  { label: "User Management", href: "user-management", icon: "fa-users-gear", color: "text-purple-500" },
  { label: "Employees", href: "addEmployee", icon: "fa-id-card", color: "text-indigo-500" },
  { label: "Payroll", href: "payroll", icon: "fa-money-check-dollar", color: "text-purple-500" },
  { label: "Generate Payroll", href: "PayrolManagement", icon: "fa-calculator", color: "text-purple-400" },
  { label: "Leave Requests", href: "leaveList", icon: "fa-calendar-check", color: "text-teal-500" },
  { label: "Active Sessions", href: "active_sessions", icon: "fa-signal", color: "text-green-500" },
  { label: "Activity Logs", href: "logs", icon: "fa-timeline", color: "text-orange-500" },
];

/** Find a page's title/icon by its href: navbar first, then the off-menu catalog. */
export function findMenuItem(href) {
  for (const list of [[...MENU, { items: ACCOUNT_ITEMS }], [...PAGE_CATALOG, { items: ACCOUNT_CATALOG }]]) {
    for (const group of list) {
      if (group.href === href) return group;
      const hit = group.items?.find((i) => i.href === href);
      if (hit) return hit;
    }
  }
  return null;
}

/** Which section a page belongs to (for breadcrumbs). */
export function groupOf(href) {
  for (const list of [MENU, PAGE_CATALOG]) for (const g of list) if (g.items?.some((i) => i.href === href)) return g.label;
  if ([...ACCOUNT_ITEMS, ...ACCOUNT_CATALOG].some((i) => i.href === href)) return "Account";
  return null;
}

/* ───────────────────────── STYLES ───────────────────────── */
const CSS = `
:root{
  --nav-bg:rgba(255,255,255,.85);
  --ink:#18181b; --ink-2:#3f3f46; --muted:#71717a; --faint:#a1a1aa;
  --line:#e4e4e7; --surface:#f4f4f5;
  --brand:#4f46e5; --brand-ink:#4338ca; --brand-soft:#eef2ff;
  --danger:#e11d48; --danger-soft:#fff1f2;
}
html{scroll-behavior:smooth}
.glass-nav{background:var(--nav-bg);backdrop-filter:blur(16px) saturate(180%);-webkit-backdrop-filter:blur(16px) saturate(180%);border-bottom:1px solid var(--line);transition:box-shadow .2s}
.glass-nav.scrolled{box-shadow:0 1px 2px rgba(24,24,27,.04),0 8px 24px -12px rgba(24,24,27,.12)}
.logo-icon{background:var(--brand);box-shadow:inset 0 1px 0 rgba(255,255,255,.25),0 4px 12px -4px rgba(79,70,229,.6)}
.brand-title{color:var(--ink);letter-spacing:-.01em}
.brand-sub{color:var(--muted)}
.nav-item{position:relative;padding:.5rem 0}
.nav-link{display:flex;align-items:center;gap:.45rem;padding:.5rem .75rem;color:var(--ink-2);text-decoration:none;border-radius:.625rem;transition:background .15s,color .15s;font-weight:500;font-size:.8125rem;background:none;border:0;cursor:pointer}
.nav-link i{color:var(--faint);transition:color .15s}
.nav-link:hover{background:var(--surface);color:var(--ink)}
.nav-link:hover i{color:var(--muted)}
.nav-item.open .nav-link{background:var(--brand-soft);color:var(--brand-ink)}
.nav-item.open .nav-link i{color:var(--brand)}
.nav-link .arrow{font-size:.6rem;color:var(--faint);transition:transform .2s ease}
.nav-item.open .nav-link .arrow{transform:rotate(180deg);color:var(--brand)}
.dropdown{position:absolute;top:calc(100% - .25rem);left:0;min-width:270px;max-height:75vh;overflow-y:auto;background:#fff;border:1px solid var(--line);border-radius:.875rem;box-shadow:0 16px 40px -12px rgba(24,24,27,.18),0 2px 6px -2px rgba(24,24,27,.06);padding:.375rem;z-index:1000;opacity:0;transform:translateY(-6px) scale(.98);transform-origin:top left;transition:opacity .15s ease,transform .15s ease;pointer-events:none;visibility:hidden}
.dropdown.open{opacity:1;transform:none;pointer-events:auto;visibility:visible}
.dropdown.right{right:0;left:auto;transform-origin:top right}
.dropdown-section-label{font-size:.6875rem;font-weight:600;color:var(--faint);padding:.625rem .75rem .25rem}
.dropdown-divider{height:1px;background:var(--line);margin:.375rem .5rem}
.dropdown-item{display:flex;align-items:center;gap:.625rem;padding:.4rem .5rem;color:var(--ink-2);text-decoration:none;border-radius:.5rem;transition:background .12s,color .12s;font-size:.8125rem;font-weight:500}
.icon-chip{width:1.75rem;height:1.75rem;border-radius:.5rem;display:inline-flex;align-items:center;justify-content:center;background:var(--surface);color:var(--muted);flex-shrink:0;font-size:.8rem;transition:background .12s}
.dropdown-item:hover{background:var(--surface);color:var(--ink)}
.dropdown-item:hover .icon-chip{background:var(--brand-soft)}
.dropdown-item.danger{color:var(--danger)}
.dropdown-item.danger .icon-chip{background:var(--danger-soft);color:var(--danger)}
.dropdown-item.danger:hover{background:var(--danger-soft)}
.user-badge{display:inline-flex;align-items:center;gap:.5rem;padding:.25rem .65rem .25rem .25rem;background:#fff;border:1px solid var(--line);border-radius:9999px;font-weight:600;font-size:.8125rem;color:var(--ink)}
.user-badge:hover{background:var(--surface)}
.avatar{width:1.75rem;height:1.75rem;border-radius:9999px;background:var(--brand);color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:.75rem;font-weight:700}
.avatar.lg{width:2.75rem;height:2.75rem;font-size:1rem}
.admin-badge{display:inline-flex;align-items:center;gap:.25rem;font-size:.65rem;font-weight:700;padding:.1rem .45rem;border-radius:999px;background:#fef3c7;color:#92400e}
.admin-badge i{font-size:.6rem;color:#d97706}
.nav-link:focus-visible,.dropdown-item:focus-visible,.mobile-menu-link:focus-visible,.mobile-submenu-item:focus-visible{outline:2px solid var(--brand);outline-offset:2px}
.mobile-menu{position:fixed;top:0;left:0;box-sizing:border-box;width:100%;max-width:380px;height:100vh;background:#fff;z-index:9999;overflow-y:auto;padding:1.25rem;border-right:1px solid var(--line);transform:translateX(-100%);visibility:hidden;transition:transform .3s cubic-bezier(.4,0,.2,1),visibility .3s}
.mobile-menu.active{transform:none;visibility:visible;box-shadow:24px 0 48px -24px rgba(24,24,27,.25)}
.mobile-menu-link{display:flex;width:100%;align-items:center;gap:.75rem;padding:.75rem;color:var(--ink-2);text-decoration:none;border-radius:.625rem;transition:background .15s,color .15s;font-weight:500;font-size:.9375rem;background:none;border:0;cursor:pointer;text-align:left}
.mobile-menu-link i{color:var(--faint);width:1.25rem;text-align:center}
.mobile-menu-link:hover{background:var(--surface);color:var(--ink)}
.mobile-menu-link[aria-expanded="true"]{background:var(--brand-soft);color:var(--brand-ink)}
.mobile-menu-link[aria-expanded="true"] i{color:var(--brand)}
.mobile-submenu{margin:.25rem 0 .5rem 1.375rem;padding-left:.75rem;border-left:1px solid var(--line);animation:slideDown .2s ease}
@keyframes slideDown{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}
.mobile-submenu-item{padding:.55rem .75rem;color:var(--ink-2);text-decoration:none;display:flex;align-items:center;gap:.75rem;border-radius:.5rem;font-size:.875rem;transition:background .12s,color .12s}
.mobile-submenu-item i{width:1rem;text-align:center}
.mobile-submenu-item:hover{background:var(--surface);color:var(--ink)}
.mobile-submenu-label{font-size:.6875rem;font-weight:600;color:var(--faint);padding:.5rem .75rem .25rem}
.mobile-logout{color:var(--danger)!important;background:var(--danger-soft)!important}
.mobile-logout i{color:var(--danger)!important}
.mobile-overlay{position:fixed;inset:0;background:rgba(24,24,27,.3);z-index:9998;backdrop-filter:blur(2px)}
@media (max-width:1023px){.desktop-menu{display:none!important}}
@media (min-width:1024px){.mobile-menu-button{display:none}}
@media (prefers-reduced-motion:reduce){.dropdown,.mobile-menu,.mobile-submenu{transition:none;animation:none}}
*{-webkit-tap-highlight-color:transparent}
`;

const DefaultLink = ({ href, children, ...rest }) => <a href={href} {...rest}>{children}</a>;

function DesktopDropdown({ items, alignRight, open, Link, onNavigate, footer }) {
  return (
    <div className={`dropdown ${open ? "open" : ""} ${alignRight ? "right" : ""}`} role="menu">
      {items.map((item, idx) => {
        if (item.type === "label") return <div key={idx} className="dropdown-section-label">{item.label}</div>;
        if (item.type === "divider") return <div key={idx} className="dropdown-divider" />;
        return (
          <Link key={idx} href={item.href} className="dropdown-item" role="menuitem" onClick={onNavigate}>
            <span className="icon-chip"><i className={`fas ${item.icon} ${item.color || ""}`} /></span>
            <span>{item.label}</span>
          </Link>
        );
      })}
      {footer}
    </div>
  );
}

export default function AE2CNavbar({
  username = "User",
  logoutHref = "../logout",
  onLogout,
  LinkComponent = DefaultLink,
  lockBackButton = false, // off by default: history.go(1) fights client-side routers
  isAdmin = false,          // shows the admin-only items, like $is_admin in header.php
}) {
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSub, setMobileSub] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const Link = LinkComponent;
  const initial = (username || "U").trim().charAt(0).toUpperCase();

  useEffect(() => {
    if (!lockBackButton) return;
    window.history.pushState(null, "", window.location.href);
    const onPop = () => window.history.go(1);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [lockBackButton]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileOpen]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") { setOpenMenu(null); setMobileOpen(false); } };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const closeMobile = () => setTimeout(() => { setMobileOpen(false); setMobileSub(null); }, 150);
  const handleLogout = (e) => { if (onLogout) { e.preventDefault(); onLogout(e); } };

  const logoutLink = (
    <>
      <div className="dropdown-divider" />
      <Link href={logoutHref} className="dropdown-item danger" onClick={handleLogout}>
        <span className="icon-chip"><i className="fas fa-arrow-right-from-bracket" /></span>
        <span>Logout</span>
      </Link>
    </>
  );

  const itemProps = (key) => ({
    className: `nav-item ${openMenu === key ? "open" : ""}`,
    onMouseEnter: () => setOpenMenu(key),
    onMouseLeave: () => setOpenMenu(null),
    onBlur: (e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOpenMenu(null); },
  });

  const menu = MENU.map((m) => (m.items ? { ...m, items: visibleItems(m.items, isAdmin) } : m)).filter((m) => !m.items || m.items.length);
  const accountItems = visibleItems(ACCOUNT_ITEMS, isAdmin);
  const mobileSections = [...menu, { key: "account", label: "Account", icon: "fa-circle-user", items: accountItems }];

  return (
    <>
      <style>{CSS}</style>

      <header className={`glass-nav fixed top-0 left-0 w-full z-50 ${scrolled ? "scrolled" : ""}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-3">
              <div className="logo-icon w-10 h-10 rounded-xl flex items-center justify-center">
                <i className="fas fa-diagram-project text-white text-lg" />
              </div>
              <div>
                <h1 className="brand-title font-bold text-base leading-tight">AE2C Enterprise</h1>
                <p className="brand-sub text-xs font-medium">ERP System</p>
              </div>
            </div>

            <nav className="desktop-menu hidden lg:flex items-center gap-0.5">
              {menu.map((menu) =>
                !menu.items ? (
                  <div key={menu.key} className="nav-item">
                    <Link href={menu.href} className="nav-link">
                      <i className={`fas ${menu.icon}`} />
                      <span>{menu.label}</span>
                    </Link>
                  </div>
                ) : (
                  <div key={menu.key} {...itemProps(menu.key)}>
                    <button type="button" className="nav-link" aria-haspopup="menu" aria-expanded={openMenu === menu.key}
                      onClick={() => setOpenMenu(openMenu === menu.key ? null : menu.key)}>
                      <i className={`fas ${menu.icon}`} />
                      <span>{menu.label}</span>
                      <span className="arrow">▼</span>
                    </button>
                    <DesktopDropdown items={menu.items} open={openMenu === menu.key} Link={Link} onNavigate={() => setOpenMenu(null)} />
                  </div>
                )
              )}

              <div {...itemProps("user")}>
                <button type="button" className="nav-link user-badge" aria-haspopup="menu" aria-expanded={openMenu === "user"}
                  onClick={() => setOpenMenu(openMenu === "user" ? null : "user")}>
                  <span className="avatar">{initial}</span>
                  <span>{username}</span>
                  {isAdmin && <span className="admin-badge"><i className="fas fa-crown" /> Admin</span>}
                  <span className="arrow">▼</span>
                </button>
                <DesktopDropdown items={accountItems} alignRight open={openMenu === "user"} Link={Link}
                  onNavigate={() => setOpenMenu(null)} footer={logoutLink} />
              </div>
            </nav>

            <button type="button" aria-label="Open menu"
              className="mobile-menu-button lg:hidden w-10 h-10 rounded-lg bg-white border border-zinc-200 hover:bg-zinc-100 transition"
              onClick={() => setMobileOpen(true)}>
              <i className="fas fa-bars text-zinc-700" />
            </button>
          </div>
        </div>
      </header>

      {mobileOpen && <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />}

      <aside className={`mobile-menu ${mobileOpen ? "active" : ""}`} aria-hidden={!mobileOpen}>
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-3">
            <div className="logo-icon w-10 h-10 rounded-xl flex items-center justify-center">
              <i className="fas fa-diagram-project text-white text-lg" />
            </div>
            <div>
              <h2 className="brand-title font-bold text-base">AE2C Enterprise</h2>
              <p className="brand-sub text-xs font-medium">ERP System</p>
            </div>
          </div>
          <button type="button" aria-label="Close menu"
            className="text-zinc-500 text-xl w-10 h-10 hover:bg-zinc-100 rounded-lg transition"
            onClick={() => setMobileOpen(false)}>
            <i className="fas fa-xmark" />
          </button>
        </div>

        <div className="bg-zinc-50 rounded-xl p-3 mb-4 border border-zinc-200">
          <div className="flex items-center gap-3">
            <span className="avatar lg">{initial}</span>
            <div>
              <p className="text-zinc-900 font-semibold">{username}</p>
              <p className="text-zinc-500 text-xs font-medium">Signed in</p>
            </div>
          </div>
        </div>

        <nav className="space-y-1">
          {mobileSections.map((menu) =>
            !menu.items ? (
              <Link key={menu.key} href={menu.href} className="mobile-menu-link" onClick={closeMobile}>
                <i className={`fas ${menu.icon}`} />
                <span>{menu.label}</span>
              </Link>
            ) : (
              <div key={menu.key}>
                <button type="button" className="mobile-menu-link" aria-expanded={mobileSub === menu.key}
                  onClick={() => setMobileSub(mobileSub === menu.key ? null : menu.key)}>
                  <i className={`fas ${menu.icon}`} />
                  <span>{menu.label}</span>
                  <i className="fas fa-chevron-down ml-auto text-sm"
                    style={{ transition: "transform .3s ease", transform: mobileSub === menu.key ? "rotate(180deg)" : "none" }} />
                </button>
                {mobileSub === menu.key && (
                  <div className="mobile-submenu">
                    {menu.items.map((item, idx) => {
                      if (item.type === "label") return <div key={idx} className="mobile-submenu-label">{item.label}</div>;
                      if (item.type === "divider") return null;
                      return (
                        <Link key={idx} href={item.href} className="mobile-submenu-item" onClick={closeMobile}>
                          <i className={`fas ${item.icon} ${item.color || ""}`} />
                          <span>{item.mobileLabel || item.label}</span>
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            )
          )}

          <div className="mt-4 pt-4 border-t border-zinc-200">
            <Link href={logoutHref} className="mobile-menu-link mobile-logout" onClick={handleLogout}>
              <i className="fas fa-arrow-right-from-bracket" />
              <span>Logout</span>
            </Link>
          </div>
        </nav>
      </aside>

      <div className="h-16" />
    </>
  );
}
